import Link from 'next/link'
import { HomeParagraph } from './base'

const year = new Date().getFullYear()

const Footer = () => {
  return (
    <footer className='bg-neutral-800 text-neutral-100 text-center py-6'>
      <div className='lp-container mx-auto px-6'>
        <div className='mb-3'>
          <Link href='/privacy-policy' className='text-neutral-300 hover:text-white transition-colors text-sm'>
            Privacy Policy
          </Link>
        </div>
        <HomeParagraph size='sm' color='muted' align='center'>
          Copyright © RTSC {year}
        </HomeParagraph>
      </div>
    </footer>
  )
}

export default Footer
